module.exports = __webpack_public_path__ + "img/matImage.a8c003fa.svg";